module.exports = __webpack_public_path__ + "static/media/w_cloudy.4c9182b5.svg";